import {
  Grid,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
import React from "react";
import "styled-components/macro";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Dialog from "components/Dialog";

import useText from "constants/text";

export interface Passwords {
  old_password: string;
  new_password: string;
  repeat_password: string;
}
export interface UpdateProfilProps {
  handlePasswordChange: (passwords: Passwords) => void;
  cancel?: () => void;
  open: boolean;
}
const defaultValue: Passwords = {
  old_password: "",
  new_password: "",
  repeat_password: "",
};

export function ChangePassword({ handlePasswordChange, cancel, open }: UpdateProfilProps) {
  const [formValues, setFormValues] = React.useState<Passwords>(defaultValue);
  const [isFormSubmited, setFormSubmited] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState("");
  const [error, setError] = React.useState(null);
  const { text } = useText();
  const handleInputChange = React.useCallback(
    (event: any) => {
      setFormValues({
        ...formValues,
        [event.target.name]: event.target.value,
      });
    },
    [formValues]
  );

  const handleConfirm = () => {
    setFormSubmited(true);
    for (const el in formValues) if (formValues[el]?.length < 6) return;
    if (formValues.repeat_password !== formValues.new_password) {
      setError("Your new password doesn't match.");
      return;
    }
    setError(null);
    handlePasswordChange(formValues);
  };

  React.useEffect(() => {
    if (open) {
      setFormValues(defaultValue);
    }
  }, [open]);
  const handleClickShowPassword = (value: string) => {
    setShowPassword(showPassword === value ? "" : value);
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return (
    <Dialog
      title={text.user.change_password}
      open={open}
      handleClose={() => cancel()}
      confirmButtonTitle={text.all.confirm}
      handleConfirm={() => {
        handleConfirm();
      }}
      maxWidth="lg"
      key="add user dialog"
    >
      <Grid
        container
        spacing={4}
        style={{
          padding: "54px 54px",
          marginTop: 0,
        }}
        css={`
          &.MuiGrid-container {
            justify-content: center;
          }
        `}
      >
        <Grid item xs={10}>
          <FormControl variant="outlined" required fullWidth>
            <InputLabel htmlFor="outlined-adornment-password">{text.user.old_password}</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword === "old" ? "text" : "password"}
              value={formValues.old_password}
              name="old_password"
              onChange={handleInputChange}
              error={isFormSubmited && formValues?.old_password?.length === 0}
              required
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle old password visibility"
                    onClick={() => handleClickShowPassword("old")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword === "old" ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
        </Grid>
        <Grid item xs={10}>
          <FormControl variant="outlined" required fullWidth>
            <InputLabel htmlFor="outlined-adornment-new-password">
              {text.user.new_password}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-new-password"
              type={showPassword === "new" ? "text" : "password"}
              value={formValues.new_password}
              name="new_password"
              onChange={handleInputChange}
              error={isFormSubmited && formValues?.new_password?.length === 0}
              required
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle new password visibility"
                    onClick={() => handleClickShowPassword("new")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword === "new" ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
            {isFormSubmited &&
              formValues?.new_password?.length !== 0 &&
              formValues.new_password.length < 6 && (
                <FormHelperText
                  id="my-helper-text"
                  style={{
                    color: "red",
                  }}
                >
                  {text.user.password_helpertext}
                </FormHelperText>
              )}
          </FormControl>
        </Grid>
        <Grid item xs={10}>
          <FormControl variant="outlined" required fullWidth>
            <InputLabel htmlFor="outlined-adornment-repeat-password">
              {text.user.repeat_password}
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-repeat-password"
              type={showPassword === "repeat" ? "text" : "password"}
              value={formValues.repeat_password}
              name="repeat_password"
              onChange={handleInputChange}
              error={isFormSubmited && formValues?.repeat_password?.length === 0}
              required
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle repeat password visibility"
                    onClick={() => handleClickShowPassword("repeat")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword === "repeat" ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
            {(isFormSubmited &&
              formValues?.repeat_password?.length !== 0 &&
              formValues.repeat_password.length < 6) ||
              (error && (
                <FormHelperText
                  id="my-helper-text"
                  style={{
                    color: "red",
                  }}
                >
                  {error ?? `${text.user.password_helpertext}`}
                </FormHelperText>
              ))}
          </FormControl>
        </Grid>
      </Grid>
    </Dialog>
  );
}
